@if (isLoading || isReportLoading) {
  <div class="flex items-center justify-center min-h-[400px]">
      <div class="flex justify-center">
        <div>
          <svg aria-hidden="true"
               class="w-12 h-12 text-gray-200 animate-spin fill-blue-600"
               viewBox="0 0 100 101"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"/>
          </svg>
        </div>
      </div>
      <div class="ms-5">
        <p class="justify-center  text-gray-900 text-sm font-medium font-['Inter'] leading-5">
          Estamos gerando o relatório no momento.</p>
        <p class="text-start justify-center text-gray-500 text-xs font-normal font-['Inter'] leading-tight">
          Obrigado pela paciência.
        </p>
      </div>
  </div>
} @else if (realEstate) {
  <div class="grid grid-cols-12 my-10 gap-x-20">
    <div class="col-span-10 col-start-2">
      <h1 class="text-center justify-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-10">
        {{ realEstate?.real_estate_type }} - {{ realEstate?.federation_state }} - {{ realEstate?.city }}
                                           - {{ realEstate?.neighborhood }}
      </h1>
    </div>
  </div>

  <div class="grid grid-cols-12 my-10 gap-x-20">
    <div class="col-span-5 col-start-2">
      <div id="default-carousel"
           class="relative w-full"
           [attr.data-carousel]="(realEstate?.images && realEstate.images.length > 1) ? 'slide' : null">
        <!-- Carousel wrapper -->

        <div class="relative h-56 overflow-hidden rounded-md md:h-96">
          @if (realEstate?.images?.length === 1) {
            <div>
              <img [src]="realEstate.images[0]"
                   class="h-100 w-full overflow-hidden"
                   alt="">
            </div>
          } @else {
            @for (image of realEstate?.images; track $index) {
              <div class="hidden duration-700 ease-in-out"
                   [attr.data-carousel-item]="true">
                <img [src]="image"
                     class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                     [alt]="'Real Estate Image ' + ($index + 1)">
              </div>
            }
          }
        </div>
        <!-- Slider indicators -->
        @if (realEstate?.images && realEstate.images.length > 1) {
          <div class="absolute z-30 flex -translate-x-1/2 bottom-5 left-1/2 space-x-3 rtl:space-x-reverse">
            @for (image of realEstate?.images; track $index) {
              <button type="button"
                      class="w-3 h-3 rounded-full"
                      [attr.aria-current]="$index === 0 ? 'true' : 'false'"
                      [attr.aria-label]="'Slide ' + ($index + 1)"
                      [attr.data-carousel-slide-to]="$index"></button>
            }
          </div>
          <!-- Slider controls -->
          <button type="button"
                  class="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                  [attr.data-carousel-prev]="true">
          <span
            class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 group-hover:bg-white/50 group-focus:ring-4 group-focus:ring-white  group-focus:outline-none">
            <svg class="w-4 h-4 text-white rtl:rotate-180"
                 aria-hidden="true"
                 xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 viewBox="0 0 6 10">
              <path stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 1 1 5l4 4"/>
            </svg>
            <span class="sr-only">Anterior</span>
          </span>
          </button>
          <button type="button"
                  class="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                  [attr.data-carousel-next]="true">
          <span
            class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30  group-hover:bg-white/50  group-focus:ring-4 group-focus:ring-white  group-focus:outline-none">
            <svg class="w-4 h-4 text-white  rtl:rotate-180"
                 aria-hidden="true"
                 xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 viewBox="0 0 6 10">
              <path stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 9 4-4-4-4"/>
            </svg>
            <span class="sr-only">Próximo</span>
          </span>
          </button>
        }
      </div>
    </div>
    <div class="col-span-5">
      <div class="flex-col col-span-10  justify-center flow-root">
        <div class="px-2 py-1 me-1 bg-green-100 rounded-md inline-block">
          <p class="text-center justify-start text-green-800 text-sm font-medium font-['Inter'] leading-normal">
            {{ realEstate?.source }}
          </p>
        </div>

        @if (realEstate?.auction_type) {
          <div class="px-2 py-1  me-1 bg-green-100 rounded-md inline-block">
            <p class="text-center justify-start text-green-800 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate?.auction_type }}
            </p>
          </div>
        }
        @if (realEstate?.occupied) {
          <div class="px-2 py-1  me-1 bg-green-100 rounded-md inline-block">
            <p class="text-center justify-start text-green-800 text-sm font-medium font-['Inter'] leading-normal">
              Ocupado
            </p>
          </div>
        }
        @if (realEstate?.sale_type) {
          <div class="px-2 py-1 me-1 bg-green-100 rounded-md inline-block">
            <p class="text-center justify-start text-green-800 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate?.sale_type }}
            </p>
          </div>
        }
      </div>

      <div class="mt-8 mb-3">
        <p class="self-stretch justify-start text-gray-900 text-base font-medium font-['Inter'] leading-6">Sobre o Imóvel</p>
      </div>
      <div class="flex-col col-span-10  justify-center flow-root">
        @if (realEstate?.real_estate_type) {
          <div
            class="px-2 py-1 me-2 bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate?.real_estate_type }}
            </p>
          </div>
        }
        @if (realEstate?.occupied) {
          <div
            class="px-2 py-1 me-2 bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              Ocupado
            </p>
          </div>
        }

        @if (realEstate?.land_area) {
          <div
            class="px-2 py-1 me-2 bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate.land_area }}m² área do terreno
            </p>
          </div>
        }

        @if (realEstate?.built_up_area) {
          <div
            class="px-2 py-1 me-2 bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate.built_up_area }}m² de área construída
            </p>
          </div>
        }

        @if (realEstate?.private_area) {
          <div
            class="px-2 py-1 me-2 bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate.private_area }}m² área privativa
            </p>
          </div>
        }

        @if (realEstate?.total_area) {
          <div
            class="px-3 py-0.5 mt-3 me-2  bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate.total_area }}m² área total
            </p>
          </div>
        }

        @if (realEstate?.parking_spaces) {
          <div
            class="px-3 py-0.5 mt-3 me-2  bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate.parking_spaces }} vaga(s) de garagem
            </p>
          </div>
        }

        @if (realEstate?.bedrooms) {
          <div
            class="px-3 py-0.5 mt-3 me-2  bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate.bedrooms }} quarto(s)
            </p>
          </div>
        }

        @if (realEstate.suites) {
          <div
            class="px-3 py-0.5 mt-3 me-2  bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate.suites }} suíte(s)
            </p>
          </div>
        }

        @if (realEstate?.toilets) {
          <div
            class="px-3 py-0.5 mt-3 me-2  bg-gray-50 rounded-md outline-1 outline-offset-[-1px] outline-gray-300 inline-block">
            <p class="text-center justify-start text-gray-500 text-sm font-medium font-['Inter'] leading-normal">
              {{ realEstate.toilets }} benheiro(s)
            </p>
          </div>
        }
      </div>

      @if (realEstate.assessment_price) {
        <div class="mt-4 pt-4 border-t border-gray-200">
          <p class="w-28 justify-start text-gray-500 text-base font-normal font-['Inter'] leading-normal">Valor avaliado</p>
          <p [class.line-through]=checkAuctionPriceBelowAssessmentPrice()
             class="justify-start
                  text-Colors-Indigo
                  text-2xl
                  font-normal
                  font-['Inter']
                  leading-loose
                  text-indigo-500">
            {{ realEstate.assessment_price | currency: 'BRL' }}
          </p>
        </div>
      }

      <div class="mt-4 pt-4 border-t border-gray-200">
        @if (realEstate.sale_type == 'Leilão SFI - Edital Único' || realEstate.sale_type == null) {
          <p [class.line-through]=checkPastDate(realEstate?.auction_1_start_date)
          class="text-gray-500 text-xs font-normal font-['Roboto'] line-through leading-4 tracking-wide">
            1ª Leilão {{ realEstate.auction_1_start_date | date:'dd/MM/yy HH:mm':'UTC' }}
            - LANCE MÍNIMO: {{ realEstate.auction_1_price | currency: 'BRL' }}
            @if (realEstate?.auction_1_discount) {
              <span
                class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
                  <svg class="w-4 h-4 text-green-800  inline-block"
                       aria-hidden="true"
                       xmlns="http://www.w3.org/2000/svg"
                       width="24"
                       height="24"
                       fill="none"
                       viewBox="0 0 24 24">
                    <path stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 19V5m0 14-4-4m4 4 4-4"/>
                  </svg>
                {{ realEstate.auction_1_discount | number:'.0-0' }}%
                </span>
            }
          </p>
          @if (realEstate.auction_2_start_date != null || realEstate.auction_2_price != null) {
            <p class="mt-3 text-gray-500 text-xs font-normal font-['Roboto'] line-through leading-4 tracking-wide"
               [class.line-through]=checkPastDate(realEstate.auction_2_start_date)>
              2ª Leilão {{ realEstate.auction_2_start_date | date:'dd/MM/yy HH:mm':'UTC' }}
              - LANCE MÍNIMO: {{ realEstate.auction_2_price | currency: 'BRL' }}
              @if (realEstate?.auction_2_discount) {
                <span
                  class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
                  <svg class="w-4 h-4 text-green-800 inline-block"
                       aria-hidden="true"
                       xmlns="http://www.w3.org/2000/svg"
                       width="24"
                       height="24"
                       fill="none"
                       viewBox="0 0 24 24">
                    <path stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 19V5m0 14-4-4m4 4 4-4"/>
                  </svg>
                  {{ realEstate.auction_2_discount | number:'.0-0' }}%
                </span>
              }
            </p>

          }
        } @else if (realEstate.sale_type != 'Leilão SFI - Edital Único') {
          <p>Valor mínimo de venda: {{ realEstate.minimum_selling_price | currency: 'BRL' }}
            <span class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
              <svg class="w-4 h-4 text-green-800  inline-block"
                   aria-hidden="true"
                   xmlns="http://www.w3.org/2000/svg"
                   width="24"
                   height="24"
                   fill="none"
                   viewBox="0 0 24 24">
                <path stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 19V5m0 14-4-4m4 4 4-4"/>
              </svg>
              {{ realEstate.discount | number:'.0-0' }}%</span>
          </p>
        }
      </div>
      @if (realEstate.lat && realEstate.lng) {
        <div class="mt-5">
          <div class="w-full h-64 rounded-md overflow-hidden border border-gray-200">
            <google-map
              [center]="{ lat: realEstate.lat, lng: realEstate.lng }"
              [zoom]="15"
              [options]="{ disableDefaultUI: false, mapTypeControl: false }"
              width="100%"
              height="100%">
              <map-marker
                [position]="{ lat: realEstate.lat, lng: realEstate.lng }"
                [options]="{ title: realEstate.city + ' - ' + realEstate.neighborhood }">
              </map-marker>
            </google-map>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="grid grid-cols-12 mb-5">
    <div class="col-start-2 col-span-10 ">
      <ul class="flex flex-wrap -mb-px text-sm font-medium text-start"
          id="default-styled-tab"
          data-tabs-toggle="#default-styled-tab-content"
          data-tabs-active-classes="text-purple hover:text-purple border-purple text-blue-500"
          data-tabs-inactive-classes="text-body hover:text-fg-brand border-default hover:border-brand text-gray-500"
          role="tablist">
          <li role="presentation">
              <button
                class="inline-block p-4 ps-0 text-Miscellaneous-Tab-Bar-Selection text-sm font-medium font-['Inter'] leading-5 border-b-2 rounded-t-base"
                id="profile-styled-tab"
                data-tabs-target="#official-auction-information"
                type="button"
                role="tab"
                aria-controls="official-auction-information"
                aria-selected="false">
                Informações Oficial do Leilão
              </button>
          </li>
          <li role="presentation">
              <button
                class="inline-block p-4 ps-0 text-Miscellaneous-Tab-Bar-Selection text-sm font-medium font-['Inter'] leading-5 border-b-2 rounded-t-base"
                id="dashboard-styled-tab"
                data-tabs-target="#registration-analysis"
                type="button"
                role="tab"
                aria-controls="registration-analysis"
                aria-selected="false">
                Análise de Matrícula
              </button>
          </li>
          <li role="presentation">
              <button class="inline-block p-4 ps-0 text-Miscellaneous-Tab-Bar-Selection text-sm font-medium font-['Inter'] leading-5 border-b-2 rounded-t-base"
                      id="settings-styled-tab"
                      data-tabs-target="#cost-analysis"
                      type="button"
                      role="tab"
                      aria-controls="cost-analysis"
                      aria-selected="false">
                Análise de Custo Ideal
              </button>
          </li>
          <li role="presentation">
              <button class="inline-block p-4 ps-0 text-Miscellaneous-Tab-Bar-Selection text-sm font-medium font-['Inter'] leading-5 border-b-2 rounded-t-base"
                      id="contacts-styled-tab"
                      data-tabs-target="#our-considerations"
                      type="button"
                      role="tab"
                      aria-controls="our-considerations"
                      aria-selected="false">
                Considerações da Casato Brasil
              </button>
          </li>
          <li role="presentation">
              <button class="inline-block p-4 ps-0 text-Miscellaneous-Tab-Bar-Selection text-sm font-medium font-['Inter'] leading-5 border-b-2 rounded-t-base hover:text-fg-brand hover:border-brand"
                      id="references-styled-tab"
                      data-tabs-target="#references"
                      type="button"
                      role="tab"
                      aria-controls="references"
                      aria-selected="false">
                Referências Utilizadas
              </button>
          </li>
      </ul>
    </div>
  </div>

  <div class="grid grid-cols-12 mb-20"
       id="default-styled-tab-content">
    <div class="col-start-2 col-span-10">

      <div class="grid grid-col-10"
           id="official-auction-information"
           role="tabpanel"
           aria-labelledby="profile-tab">
          <div class="col-start-1 col-span-7">
            <div>
              <p class="justify-start text-base font-bold font-['Inter'] leading-normal">
                Os documentos listados abaixo estão disponíveis no site oficial do leiloeiro. Ao clicar no link, você será direcionado ao download direto dos arquivos.
              </p>
              <div class="mt-5 rounded-md"
                   id="files">
                @if (realEstate?.documents) {
                  @for (file of realEstate.documents | keyvalue; track file.key) {
                    <a class="text-blue-600 justify-start text-primary-700 text-sm font-normal font-['Inter'] block mb-3"
                       [href]="file.value"
                       target="_blank">{{ file.key.charAt(0).toUpperCase() + file.key.slice(1).toLowerCase() }}
                    </a>
                  }
                } @else {
                  <p class="text-sm text-gray-500">Nenhum documento disponível.</p>
                }
              </div>
            </div>
          </div>
          <div class="col-start-8 col-span-3">
            <div class="bg-gray-50 p-8 rounded-xl">
              <h4 class="font-semibold text-gray-900 text-xl mb-5 font-['Inter']">Sobre o leilão</h4>
              <div class="flex justify-between pb-2 -2 border-gray-300 ">
                <p class="order-1 text-sm font-medium text-gray-900">Comitente</p>
                <p class="order-2 text-sm font-normal text-gray-500">{{ realEstate.auctioneer }}</p>
              </div>
              <div class="flex justify-between pb-2 -2 border-gray-300 mt-3">
                <p class="order-1 text-sm font-medium text-gray-900">Leiloeiro</p>
                <p class="order-2 text-sm font-normal text-gray-500">{{ realEstate.auctioneer }}</p>
              </div>
              <div class="flex justify-between pb-2 -2 border-gray-300 mt-3">
                <p class="order-1 text-sm font-medium text-gray-900">Tipo de Leilão</p>
                <p class="order-2 text-sm font-normal text-gray-500">{{ realEstate.auction_type }}</p>
              </div>
              <div class="flex justify-between pb-2 -2 border-gray-300 mt-3">
                <p class="order-1 text-sm font-medium text-gray-900">Modalidade</p>
                <p class="order-2 text-sm font-normal text-gray-500">{{ realEstate.sale_type }}</p>
              </div>
            </div>

            <div class="bg-gray-50 p-8 rounded-xl mt-10">
              <h4 class="font-semibold text-gray-900 text-xl mb-5 font-['Inter']">Condições de pagamento</h4>
              <p class="text-sm font-normal text-gray-900">{{ realEstate.payment_conditions }}</p>
            </div>

          </div>
      </div>

      <div class="grid grid-col-10 hidden"
                 id="registration-analysis"
                 role="tabpanel"
                 aria-labelledby="profile-tab">
          <div class="col-start-1 col-span-7">
            @for (document of realEstate?.report?.['documents_analysis']; track document.title) {
              <div class="mb-3">
                <h5 class="justify-start text-green-800 text-xl font-extrabold font-['Inter'] leading-10">{{ document.title }}</h5>
                <p class="justify-start text-gray-600 text-l font-normal font-['Inter']">{{ document.summary }}</p>
                <p class="justify-start text-gray-600 text-l font-normal font-['Inter']">{{ document.investor_impact }}</p>
                <p class="text-green-800 text-l font-extrabold font-['Inter'] mt-3">Riscos</p>
                @for (risk of document?.['risks']; track risk) {
                  <p class="text-gray-600 text-n font-normal font-['Inter'] ms-3">{{ risk }}</p>
                }
                <p class="text-green-800 text-l font-extrabold font-['Inter']">Informações extraídas</p>
                @for (fact of document.extracted_facts; track fact) {
                  <p class="text-gray-600 text-n font-normal font-['Inter'] ms-3">{{ fact }}</p>
                }
              </div>
            }
          </div>
          <div class="col-start-8 col-span-3">
          </div>
      </div>

      <div class="grid grid-col-10 hidden"
           id="cost-analysis"
           role="tabpanel"
           aria-labelledby="settings-tab">
          @if (costReport != undefined) {
            <app-financial-report [costReport]="costReport"></app-financial-report>
          }
      </div>

      <div class="grid grid-col-10 hidden"
           id="our-considerations"
           role="tabpanel"
           aria-labelledby="contacts-tab">
          <p class="text-sm text-body">This is some placeholder content the <strong class="font-medium text-heading">Contacts tab's associated content</strong>. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling.</p>
      </div>

      <div class="grid grid-col-10 hidden"
           id="references"
           role="tabpanel"
           aria-labelledby="contacts-tab">
          <div>
            <p>Our references</p>
          </div>
      </div>
    </div>
</div>


<!--  <div class="grid grid-cols-12 mb-20">-->
<!--    <div class="col-start-3 col-span-4">-->
<!--      <pre>{{ realEstate | json }}</pre>-->
<!--    </div>-->
<!--  </div>-->










}

@if (showFavoriteAlertConsentModal) {
  <app-favorite-alert-consent-modal
    [isSaving]="isSavingFavoriteAlertConsent"
    [errorMessage]="favoriteAlertConsentError"
    (accepted)="saveFavoriteAlertConsent(true)"
    (declined)="saveFavoriteAlertConsent(false)">
  </app-favorite-alert-consent-modal>
}
